// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router';
import Page from '../Page';
import queryString from 'query-string';
import { Base64 } from 'js-base64';

import type { User } from '../entities';

type Props = {
  +component: any;
  +name: string;
  +user?: User;
  +authenticated?: boolean;
};

export const AlreadyAuthRoute = ({ component: Component, user, authenticated, name, ...rest }: Props) => {
  return (
    <Route {...rest}
           render={props => {
             const parsedQuery = queryString.parse(document ? document.location.search : '');
             if (!!parsedQuery.redirect) {
               const redirectTo = Base64.decode(parsedQuery.redirect);
               return user && authenticated ? (
                 <Redirect to={{
                   pathname: redirectTo,
                   state: { from: props.location }
                 }}/>
               ) : (<Page name={name}><Component {...props} {...rest} /></Page>);
             }
             return user && authenticated ? (
               <Redirect to={{
                 pathname: '/',
                 state: { from: props.location }
               }}/>
             ) : (<Page name={name}><Component {...props} {...rest} /></Page>);
           }}/>
  );
};

AlreadyAuthRoute.propTypes = {
  component: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  user: PropTypes.object,
  authenticated: PropTypes.bool,
};

// export default AlreadyAuthRoute;



// WEBPACK FOOTER //
// ./src/router/AlreadyAuthRoute.jsx